import type {
  OrderSortKeys,
  OrderSortActivities,
  SortConfigs,
} from '../../types';

type Param = string | null | undefined;

export const getPlainSortActivity = (sortParam: Param, sortKey: string) => {
  if (!sortParam) {
    return null;
  }

  return sortParam === sortKey;
};

export const getOrderSortActivity = (
  sortParam: Param,
  sortKey: OrderSortKeys
): OrderSortActivities => {
  if (!sortParam) {
    return null;
  }

  const { asc, desc } = sortKey;

  if (sortParam === asc) {
    return 'asc';
  }

  if (sortParam === desc) {
    return 'desc';
  }

  return null;
};

export const defineOrderSortParam = (
  sortParam: Param,
  sortKey: OrderSortKeys
) => {
  const activity = getOrderSortActivity(sortParam, sortKey);

  if (!activity || activity === 'desc') {
    return sortKey.asc;
  }

  if (activity === 'asc') {
    return sortKey.desc;
  }

  return null;
};

export const pickDefaultParamFromSortConfigs = (configs: SortConfigs) => {
  const defaultSelectedConfig = configs.find((item) => item.defaultSelected);

  if (!defaultSelectedConfig) {
    return '';
  }

  const { type } = defaultSelectedConfig;

  if (type === 'plain') {
    return defaultSelectedConfig.sortKey;
  }

  if (type === 'order') {
    return defaultSelectedConfig.sortKey.asc;
  }

  return '';
};
